import axios from 'axios';
import axiosInstance from './axiosInstance';

const baseUrl = 'https://api.kollecta.io';
// const baseUrl = 'http://localhost:3003';

const getOffers = async (personalNumber, companyId) => {
  let url = `${baseUrl}/api/past-dues-unlocked?personalNumber=${personalNumber}`;
  if (companyId) {
    url += `&companyId=${companyId}`;
  }
  return await axios.get(url);
};

const validateTwoFactor = async ({ token }) => {
  return await axios.post(`${baseUrl}/auth/validate-2fa`, {
    token,
  });
};

const validateToken = async ({ token }) => {
  return await axios.post(`${baseUrl}/api/auth/validate-token`, {
    token,
  });
};

const resetPassword = async ({ token, newPassword }) => {
  return await axios.post(`${baseUrl}/api/auth/reset-password`, {
    token,
    newPassword,
  });
};

const dealOffer = async (offerId, paymentMethod, installmentDay = null, issuedBy = null) => {
  let queryString = `?paymentMethod=${paymentMethod}`;

  if (installmentDay) {
    queryString += `&installmentDay=${installmentDay}`;
  }

  if (issuedBy) {
    queryString += `&issuedBy=${issuedBy}`;
  }

  return await axios.get(`${baseUrl}/api/past-dues-deal/${offerId}${queryString}`);
}

const uploadFile = async (files) => {
  return await axiosInstance.post(`/upload`, files)
}

const getFeatureFlags = async () => {
  return await axiosInstance.get(`/feature-flags`)
}

const uploadIndirectPaymentImport = async (files) => {
  return await axiosInstance.post(`/feature-flags/indirect-payment-import`, files)
}

const auth = async (data) => {
  return await axios.post(`${baseUrl}/auth/login`, data)
}

const getSummaries = async () => {
  return await axiosInstance.get(`${baseUrl}/api/summaries`)
}

const getPastDues = async () => {
  return await axiosInstance.get(`${baseUrl}/api/past-dues`)
}

const getPastDuesById = async (id) => {
  return await axiosInstance.get(`${baseUrl}/api/past-dues/${id}`)
}

const getQueueNext = async () => {
  return await axiosInstance.get(`${baseUrl}/api/past-dues-queue-next`)
}

const getByUser = async () => {
  return await axiosInstance.get(`${baseUrl}/api/past-dues-by-user`)
}

const getByUserScheduledContact = async () => {
  return await axiosInstance.get(`${baseUrl}/api/past-dues-by-status/scheduled_contact`)
}

const resetQueueByUser = async (id) => {
  return await axiosInstance.get(`${baseUrl}/api/past-dues-reset-attendance/${id}`)
}


const getSummariesLast30Days = async () => {
  return await axiosInstance.get(`${baseUrl}/api/last-30-days`)
}

const getCurrencyValue = async (id) => {
  return await axiosInstance.get(`${baseUrl}/api/credits/${id}`)
}

const getWallet = async (id) => {
  return await axiosInstance.get(`${baseUrl}/api/wallet/${id}`)
}

const getFilters = async () => {
  return await axiosInstance.get(`${baseUrl}/api/datasets`)
}

const postWallets = async (id, filters, file) => {
  return await axiosInstance.post(`${baseUrl}/api/${id}/wallet?datasets=${filters}`, file)
}

const postWalletsSingle = async (id, filters, document) => {
  return await axiosInstance.post(`${baseUrl}/api/${id}/wallet-single?datasets=${filters}`, { document })
}

const postWalletsConfirm = async (id, companyId, filters, file) => {
  return await axiosInstance.post(`${baseUrl}/api/confirm/${id}/${companyId}/wallet?datasets=${filters}`, file)
}

const postWalletsConfirmSingle = async (id, companyId, filters, document) => {
  return await axiosInstance.post(`${baseUrl}/api/confirm/${id}/${companyId}/wallet-single?datasets=${filters}`, { document })
}
const postCreditsUpdate = async (data) => {
  return await axiosInstance.patch(`${baseUrl}/api/credits`, data)
}

const getCredits = async (id) => {
  return await axiosInstance.get(`${baseUrl}/api/credits/${id}`)
}

const naoSeiDownloadWallet = async (id) => {
  return await axiosInstance.get(`${baseUrl}/api/wallet/download/${id}`)
}

const downloadWalletSingle = async (id) => {
  return await axiosInstance.get(`${baseUrl}/api/wallet-single/download/${id}`)
}

const getCompanySettings = async (siteUrl) => {
  return await axiosInstance.get(`${baseUrl}/api/company-by-site-url?siteUrl=${siteUrl}`)
}

const postSendEmail = async (data) => {
  return await axios.post(`${baseUrl}/api/crm/send-email`, data)
}

const postSendMessage = async (data) => {
  return await axios.post(`${baseUrl}/api/crm/send-message`, data)
}

const updatePastDue = async (id, data) => {
  return await axios.put(`${baseUrl}/api/past-dues/status/${id}`, data)
}

const updateAllPastDueData = async (id, data) => {
  return await axiosInstance.put(`${baseUrl}/api/past-dues/${id}`, data)
}

const getpastDueLogs = async () => {
  return await axiosInstance.get(`${baseUrl}/api/pastdue-logs`)
}

const getpastDueLogsByDocument = async (data) => {
  return await axiosInstance.post(`${baseUrl}/api/pastdue-logs`, data)
}

const createPastdueLog = async (data) => {
  return await axiosInstance.post(`${baseUrl}/api/create-pastdue-logs`, data)
}

const getPastDueByContract = async (contract) => {
  return await axiosInstance.get(`${baseUrl}/api/past-dues-contract/${contract}`)
}

const getMonthlyGoals = async (userId) => {
  return await axiosInstance.get(`${baseUrl}/api/users-monthly-goals/${userId}`)
}

const getMonthlyGoalsByMonthly = async (userId, month) => {
  return await axiosInstance.get(`${baseUrl}/api/users-monthly-goals-monthly/${userId}/${month}`)
}

const getByUserStatus = async (status) => {
  return await axiosInstance.get(`${baseUrl}/api/past-dues-by-status/${status}`)
}

// contracts
const getPastDuesByDocument = async (personalNumber, companyDisplayName) => {
  return await axiosInstance.get(`${baseUrl}/api/past-dues-document?personalNumber=${personalNumber}&companyDisplayName=${companyDisplayName}`)
}

const getTransactionsByDocument = async (personalNumber, companyDisplayName) => {
  return await axiosInstance.get(`${baseUrl}/api/past-dues-transactions?personalNumber=${personalNumber}&companyDisplayName=${companyDisplayName}`)
}

// pastDues by Group
const getPastDuesByGroup = async (page) => {
  return await axiosInstance.get(`${baseUrl}/api/past-dues-group-company?page=${page}&limit=5000`)
}

// creditor names
const getUniqueCompanyDisplayNames = async () => {
  return await axiosInstance.get(`${baseUrl}/api/creditors`);
}

// chartPie
const getPieChartData = async (data) => {
  return await axiosInstance.post(`${baseUrl}/api/charts/pie`, data);
}

// chartLine
const getLineChartData = async (data) => {
  return await axiosInstance.post(`${baseUrl}/api/charts/line`, data);
}

// chartLine
const getBarChartData = async (data) => {
  return await axiosInstance.post(`${baseUrl}/api/charts/bar`, data);
}


// measurements pastDues
const getPastDuesMeasurements = async (data) => {
  return await axiosInstance.post(`${baseUrl}/api/past-dues/creditors`, data);
}

// reports: pagamentos (JSON paginado)
const getPaymentsReport = async ({ page = 1, pageSize = 100, companyId } = {}) => {
  const params = new URLSearchParams();
  params.append('page', String(page));
  params.append('pageSize', String(pageSize));
  if (companyId) params.append('companyId', companyId);
  return await axiosInstance.get(`${baseUrl}/api/reports/payments?${params.toString()}`);
};

// has accountbank
const hasAccountBank = async (id) => {
  return await axiosInstance.get(`${baseUrl}/api/accountbank/${id}`);
}

// usersStats by companyId
const usersStats = async (startMonth, endMonth) => {
  return await axiosInstance.get(`${baseUrl}/api/users-monthly-goals-monthly/stats/${startMonth}/${endMonth}`);
}

// filters
const getFiltersExcel = async (data) => {
  try {
    const response = await axiosInstance({
      url: `${baseUrl}/api/filters/status`,
      method: 'post',
      data: data,
      responseType: 'blob',
      headers: {
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response;
  } catch (error) {
    console.error('Erro ao buscar o arquivo Excel:', error);
    throw error;
  }
};

// pastDues filters
const filtersPastDues = async (data) => {
  return await axiosInstance.post(`${baseUrl}/api/search`, data);
}

// operators
const getOperators = async () => {
  return await axiosInstance.get(`${baseUrl}/api/operators`);
}

// create queue
const createQueue = async (data) => {
  return await axiosInstance.post(`${baseUrl}/api/queues`, data);
}

// update queue
const updateQueue = async (queueId) => {
  return await axiosInstance.put(`${baseUrl}/api/queues/${queueId}`);
}

// reset queue
const resetQueue = async (queueId) => {
  return await axiosInstance.get(`${baseUrl}/api/queues/${queueId}`);
}

// validate birthdate
const validateBirthdate = async (data) => {
  return await axiosInstance.post(`${baseUrl}/api/wallet-single/validate-birthday`, data);
}

// contact log
const createContactLog = async (data) => {
  return await axiosInstance.post(`${baseUrl}/api/contact-log`, data);
}

// Portal Access Logs
const getPortalAccessLogs = async () => {
  return await axiosInstance.get(`${baseUrl}/api/access-logs`)
}

const createPortalAccessLogs = async (data) => {
  return await axiosInstance.post(`${baseUrl}/api/access-logs-create`, data)
}

// get bot
const getBotDetails = async (id) => {
  return await axiosInstance.get(`${baseUrl}/api/bot/${id}`);
};

// get bot with botNumber
const getBotWithNumber = async (id) => {
  return await axiosInstance.get(`${baseUrl}/api/bot/${id}`);
};

// whatsapp
const getWhatsappHistory = async (bot, cellphone, companyId) => {
  return await axiosInstance.get(`${baseUrl}/api/crm/whatsapp-history/bot/${bot}/cellphone/${cellphone}/company/${companyId}`);
};

const getWhatsappHistoryBatch = async (data) => {
  return await axiosInstance.post(`${baseUrl}/api/crm/whatsapp-history/batch`, data);
};

const getCinnDiTemplates = async (botNumber) => {
  return await axiosInstance.get(`${baseUrl}/api/cinndi/templates/${botNumber}`, {});
};

const deletePastDues = async (ids) => {
  return await axiosInstance.delete(`${baseUrl}/api/company/past-dues`, { data: { ids } });
};

// communication rules
const createCommunicationRules = async (data) => {
  return await axiosInstance.post(`${baseUrl}/api/communication-rules`, data);
};

const getCommunicationRules = async () => {
  return await axiosInstance.get(`${baseUrl}/api/communication-rules`);
};

const deleteCommunicationRules = async (id) => {
  return await axiosInstance.delete(`${baseUrl}/api/communication-rules/${id}`);
};

const previewCommunicationRuleImpact = async (data) => {
  return await axiosInstance.post(`${baseUrl}/api/communication-rules/preview-impact`, data);
};

const assumeConversation = async ({ phone, companyId, personalNumber, agentId }) => {
  return await axiosInstance.post(`${baseUrl}/api/assume/conversation`, {
    phone,
    companyId,
    personalNumber,
    agentId
  });
};

const deleteRouting = async (phone, companyId, personalNumber, agentId) => {
  const qs =
    agentId !== undefined && agentId !== ''
      ? `?agentId=${encodeURIComponent(agentId)}`
      : '';
  return await axiosInstance.delete(
    `${baseUrl}/api/routing/${phone}/${companyId}/${personalNumber}${qs}`
  );
};

// completion endpoint
const sendCompletion = async (data) => {
  return await axiosInstance.post(`${baseUrl}/api/completion/send`, data);
};

// get bot by company id
const getBotByCompanyId = async (companyId) => {
  return await axiosInstance.get(`${baseUrl}/api/bot/${companyId}`);
};

const getStellaAnalyses = async (cellphone) => {
  return await axiosInstance.get(`${baseUrl}/api/livia/analyses?cellphone=${encodeURIComponent(cellphone)}`);
};

const getCampaignHistory = async (page, pageSize, startDate, endDate) => {
  const params = new URLSearchParams({
    page: page.toString(),
    pageSize: pageSize.toString(),
    startDate: startDate,
    endDate: endDate,
  });
  return await axiosInstance.get(`${baseUrl}/api/communication-rules/campaign-history?${params.toString()}`);
};

const getCampaignSummary = async (page, pageSize, startDate, endDate, groupByRule = true) => {
  const params = new URLSearchParams({
    page: page.toString(),
    pageSize: pageSize.toString(),
    startDate: startDate,
    endDate: endDate,
    groupByRule: groupByRule ? 'true' : 'false',
  });
  return await axiosInstance.get(`${baseUrl}/api/communication-rules/campaign-summary?${params.toString()}`);
};

const getCampaignStatusReport = async ({ startDate, endDate } = {}) => {
  const params = new URLSearchParams({
    startDate,
    endDate,
  });
  return await axiosInstance.get(`${baseUrl}/api/communication-rules/campaign-status-report?${params.toString()}`);
};

const getCampaignDispatchesExcel = async ({ startDate, endDate } = {}) => {
  const params = new URLSearchParams({
    startDate,
    endDate,
  });
  return await axiosInstance.get(
    `${baseUrl}/api/communication-rules/campaign-dispatches-export?${params.toString()}`,
    {
      responseType: 'blob',
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    }
  );
};

const getCampaignFirstDispatch = async () => {
  return await axiosInstance.get(`${baseUrl}/api/communication-rules/campaign-first-dispatch`);
};

const getCampaignStatusHistories = async ({ personalNumber, customerId, latestOnly = true } = {}) => {
  const params = new URLSearchParams();
  if (personalNumber) params.set('personalNumber', personalNumber);
  if (customerId) params.set('customerId', customerId);
  if (latestOnly) params.set('latestOnly', 'true');
  return await axiosInstance.get(`${baseUrl}/api/campaign-status-histories?${params.toString()}`);
}

export {
  auth,
  validateTwoFactor,
  assumeConversation,
  deleteRouting,
  validateToken,
  resetPassword,
  getBotDetails,
  getBotWithNumber,
  getBotByCompanyId,
  createContactLog,
  createPastdueLog,
  createPortalAccessLogs,
  createQueue,
  createCommunicationRules,
  getCommunicationRules,
  deleteCommunicationRules,
  previewCommunicationRuleImpact,
  dealOffer,
  deletePastDues,
  downloadWalletSingle,
  filtersPastDues,
  getByUser,
  getByUserScheduledContact,
  getByUserStatus,
  getCompanySettings,
  getCredits,
  getCurrencyValue,
  getFilters,
  getFiltersExcel,
  getLineChartData,
  getMonthlyGoals,
  getMonthlyGoalsByMonthly,
  getOffers,
  getOperators,
  getPastDueByContract,
  getPastDues,
  getPastDuesByDocument,
  getPastDuesByGroup,
  getPastDuesById,
  getPastDuesMeasurements,
  getPaymentsReport,
  getPieChartData,
  getPortalAccessLogs,
  getQueueNext,
  getSummaries,
  getSummariesLast30Days,
  getTransactionsByDocument,
  getUniqueCompanyDisplayNames,
  getWallet,
  getpastDueLogs,
  getpastDueLogsByDocument,
  hasAccountBank,
  naoSeiDownloadWallet,
  postCreditsUpdate,
  postSendEmail,
  postSendMessage,
  postWallets,
  postWalletsConfirm,
  postWalletsConfirmSingle,
  postWalletsSingle,
  resetQueue,
  resetQueueByUser,
  sendCompletion,
  updateAllPastDueData,
  updatePastDue,
  updateQueue,
  uploadFile,
  getFeatureFlags,
  uploadIndirectPaymentImport,
  usersStats,
  validateBirthdate,
  getWhatsappHistory,
  getWhatsappHistoryBatch,
  getBarChartData,
  getCinnDiTemplates,
  getCampaignHistory,
  getCampaignSummary,
  getCampaignStatusReport,
  getCampaignDispatchesExcel,
  getCampaignFirstDispatch,
  getStellaAnalyses,
  getCampaignStatusHistories,
};

